export const JUSTIFICATIVA_CONFLITOS_OBRIGATORIA = "Informe a justificativa para continuar.";
